
import analytics from '~/mixins.js/analytics'

export default {
  mixins: [analytics],
  props: {
    diagram: { type: Object },
    showButtons: { type: Boolean, default: true },
    license: { type: Object, required: false }
  },
  data: () => ({
    isLoading: false
  }),
  methods: {
    async addToCart () {
      this.isLoading = true
      await this.$store.dispatch(
        'checkout/addDiagramToCart',
        {
          diagram: this.diagram,
          $gtag: this.$gtag,
          $matomo: this.$matomo,
          $bing: this.$bing,
          license: this.license
        }
      )
      await this.$store.dispatch('checkout/showAddedToCartModal', { diagram: this.diagram, $backend: this.$backend })
      this.trackEvent('Buy button', 'Add to cart')
      this.isLoading = false
    },
    async onBuyNow () {
      await this.$store.dispatch(
        'checkout/addDiagramToCart',
        {
          diagram: this.diagram,
          $gtag: this.$gtag,
          $matomo: this.$matomo,
          $bing: this.$bing,
          license: this.license
        })
      this.trackEvent('Buy button', 'Buy now')
      await this.$router.push('/checkout/order')
    }
  }
}
